import { useAction, useAtom } from '@reatom/npm-react'

import { useHapticFeedback } from '@blade/ui-kit'
import { TransactionsIcon } from '@blade/ui-kit'
import { WatchlistRoute } from '@root/features/routing/model'
import { useTranslation } from '@root/shared/localization'
import {
  AnalyticsIcon,
  CandleChartFilledIcon,
  PositionIcon,
  Refresh2Icon,
  StarOutlineIcon,
} from '@root/shared/ui-kit'

import { changeTradingTabAction, tradingNavigationAtom } from '../../atoms'

import { BottomNavigationContainer } from './bottom-navigation-container'
import { BottomNavigationItem } from './bottom-navigation-item'

import type { TradingNavigationTab } from '../../atoms'

export const BottomNavigationTrade: React.FC = () => {
  const haptics = useHapticFeedback()
  const { t } = useTranslation()

  const changeTradingTab = useAction(changeTradingTabAction)
  const [activeTab] = useAtom(tradingNavigationAtom)

  const handleClick = (tab: TradingNavigationTab) => () => {
    haptics.impactOccurred('light')
    changeTradingTab(tab)
  }

  return (
    <BottomNavigationContainer>
      <BottomNavigationItem
        title={t('trading')}
        icon={TransactionsIcon}
        active={activeTab === 'trading'}
        onClick={handleClick('trading')}
      />
      <BottomNavigationItem
        title={t('analytics')}
        icon={AnalyticsIcon}
        active={activeTab === 'analytics'}
        onClick={handleClick('analytics')}
      />
      <BottomNavigationItem
        title={t('trading.navigation.orders')}
        icon={CandleChartFilledIcon}
        active={activeTab === 'orders'}
        onClick={handleClick('orders')}
      />
      <BottomNavigationItem
        title={t('trading.navigation.positions')}
        icon={PositionIcon}
        active={activeTab === 'positions'}
        onClick={handleClick('positions')}
      />
      <BottomNavigationItem
        title={t('trading.navigation.last-pairs')}
        icon={Refresh2Icon}
        active={activeTab === 'recent-pairs'}
        onClick={handleClick('recent-pairs')}
      />

      <BottomNavigationItem
        title={t('trading.navigation.favorites')}
        icon={StarOutlineIcon}
        to={WatchlistRoute.path}
      />
    </BottomNavigationContainer>
  )
}
